// URL change detection with event emitter pattern
type Listener = (...params: any[]) => void;

export class URLChangeDetector {
  private previousUrl: string;
  private listeners: Set<Listener>;
  private observer: MutationObserver;

  constructor() {
    this.previousUrl = location.href;
    this.listeners = new Set<Listener>();

    this.observer = new MutationObserver(this.handleUpdate);
    window.addEventListener('popstate', this.handleUpdate);

    this.observer.observe(document, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['href'],
    });
  }

  handleUpdate = () => {
    if (location.href !== this.previousUrl) {
      this.previousUrl = location.href;
      this.notifyListeners();
    }
  };

  private notifyListeners(): void {
    this.listeners.forEach((listener) => listener());
  }

  on(listener: Listener): void {
    this.listeners.add(listener);
  }

  off(listener: Listener): void {
    this.listeners.delete(listener);
  }

  destroy(): void {
    window.removeEventListener('popstate', this.handleUpdate);
    this.observer.disconnect();
    this.listeners.clear();
  }
}

// Create singleton instance
const urlChangeDetector = new URLChangeDetector();

// Export compatibility functions for existing code
export function addURLChangeListener(listener: Listener) {
  urlChangeDetector.on(listener);
}

export function removeURLChangeListener(listener: Listener) {
  urlChangeDetector.off(listener);
}

export default urlChangeDetector;
